import React from 'react';
import { DataTable } from 'primereact/components/datatable/DataTable';
import { Column } from 'primereact/components/column/Column';
import { Button } from 'primereact/components/button/Button';
import { InputText } from 'primereact/components/inputtext/InputText';
import moment from 'moment';

import clientService from '../../../../utils/services/client';
import FormElement from '../../../shared/form/FormElement';
import config from '../../../../config/config';

export default class CampaignList extends React.Component {

  constructor() {
    super();
    this.state = {
      campaignList: [],
      searchField: '',
      first: 0
    };

    this.onLazyLoad = this.onLazyLoad.bind(this);
    this.export = this.export.bind(this);
    this.resetFilter = this.resetFilter.bind(this);
    this.onCreateClient = this.onCreateClient.bind(this);
    this.onEditClient = this.onEditClient.bind(this);
    this.actionTemplate = this.actionTemplate.bind(this);
  }

  export() {
    this.dt.exportCSV();
  }

  componentDidMount() {
  }

  resetFilter(event) {
    this.setState({
      searchField: '',
    }, () => this.onLazyLoad(event));
  }

  getQuery(event) {

    let first = this.state.first;

    var query = {
      $offset: first,
      $limit: event.rows
    };

    if(this.state.searchField && this.state.searchField != '') {
      var value = { '$search' : this.state.searchField };
      query = Object.assign(query ,value);
    }

    return query;
  }

  getExtendedQuery(event){
    var extendedQuery = '?';
    if(event.multiSortMeta != null && event.multiSortMeta.length > 0) {
      for(let sortMeta of event.multiSortMeta) {
        var sortField = `$sort=${sortMeta.order == 1 ? '' : '-' }${sortMeta.field}&`;
        extendedQuery = extendedQuery + sortField;
      }
    }
    return extendedQuery;
  }

  formatData(data) {
  
    for(let row of data.data.page) {
      row.createdAt = moment(row.createdAt).format('YYYY-MM-DD');
      row.updatedAt = moment(row.updatedAt).format('YYYY-MM-DD');  
      row.expiry = moment(row.expiry).format('YYYY-MM-DD');  
      row.opsStatus = row.opsStatus || 'NEW';
    }
      
    this.setState({
      clientList: data.data.page,
      totalRecords: data.data.totalCount,
      loading: false
    });
  }

  onLazyLoad(event) {
    
    this.state.first = isNaN(event.first) ? 0 : event.first;

    this.setState({ loading: true});
    
    clientService.getClientPage(this.getQuery(event), this.getExtendedQuery(event)).then((data) => {
      this.formatData(data);
    });
    
  } 

  onCreateClient(){
    this.props.router.push({ pathname: '/admin/client/create'});
  }

  onEditClient(e,rowData){
    this.props.router.push({ pathname: '/admin/client/' + rowData._id });
  }

  onEditClientConfiguration(e,rowData){
    this.props.router.push({ pathname: '/admin/client/' + rowData._id + '/configuration' });
  }

  actionTemplate(rowData, column) {
    return <div>
      <Button type="button" icon="fa-edit" className="ui-button-warning" onClick={(e) => {this.onEditClient(e, rowData);}}> </Button>
      <a href={config.URL.BASEBACK+'/client/'+ rowData._id +'/impersonate' } >
        <Button type="button" icon="fa-eye" className="ui-button-warning"></Button>
      </a>
      <Button type="button" icon="fa-gear" className="ui-button-warning" onClick={(e) => {this.onEditClientConfiguration(e, rowData);}}> </Button>
    </div>;
  }

  render() {
    var header = <div style={{textAlign:'left'}}><Button type="button" icon="fa-file-o" iconPos="left" label="CSV" onClick={this.export}></Button></div>;

    const calendarStyle = {
      marginLeft: '5px', width: '172px', top: '-12px', position: 'relative', border: '1px solid #cccccc', margin: '0'
    };

    return (
      <div>
        <div className="content-section implementation">

          <h3>Client</h3>
          <div className="ui-g">
            <div className="ui-g-10 ui-md-2">
              <span>Search:</span>
            </div>
            <div className="ui-g-10 ui-md-10">
              <span>
                <InputText onChange={(e) => this.setState({ searchField: e.target.value })} value={this.state.searchField}/>
              </span>
            </div>
          </div>
          <div className="content-section implementation">
            <div className="ui-g">
              <div className="ui-g-3 ui-md-1">
                <Button label="Search" onClick={this.onLazyLoad} />         
              </div>
              <div className="ui-g-3 ui-md-1">
                <Button label="Reset" onClick={this.resetFilter} />         
              </div>
              <div className="ui-g-3 ui-md-1">
                <Button label="Create Client" onClick={this.onCreateClient} />         
              </div>
            </div>
          </div>

          <DataTable value={this.state.clientList} responsive={true} sortMode="multiple" paginator={true} rows={10} rowsPerPageOptions={[5,10,20,100,500,1000]} totalRecords={this.state.totalRecords}
            lazy={true} onLazyLoad={this.onLazyLoad} header={header}
            ref={(el) => this.dt = el}
            globalFilter={this.state.globalFilter} first = {this.state.first}>
            <Column field="name" header="Client" sortable={true} style={{width:'80px'}} />
            <Column field="_id" header="ID" sortable={true} style={{width:'80px'}} />
            <Column field="referer" header="Referer" sortable={true} style={{width:'90px'}} />
            <Column field="primaryContactFirstName" header="Contact First Name" sortable={true} style={{width:'40px'}} />
            <Column field="primaryContactLastName" header="Contact Last Name" sortable={true} style={{width:'40px'}} />
            <Column field="primaryContactPhone" header="Contact Phone" sortable={true} style={{width:'40px'}} />
            <Column field="primaryContactEmail" header="Contact Email" sortable={true} style={{width:'50px'}} />
            <Column field="opsStatus" header="Ops Status" sortable={true} style={{width:'40px'}} />
            <Column field="createdAt" header="Created" sortable={true} style={{width:'50px'}} />
            <Column field="updatedAt" header="Updated" sortable={true} style={{width:'50px'}} />
            <Column body={this.actionTemplate} style={{textAlign:'center', width: '50px'}}/>
          </DataTable>
        </div>
      </div>
    );
  }
}
